import { UserOrder } from "../../../../interfaces";
import { toast } from "react-toastify";
import TextAreaFieldInlineEdit from "../../../common/TextAreaFieldInlineEdit";
import useOrder from "../../../../hooks/useOrder";
import { useUser } from "../../../../contexts";
import { API, graphqlOperation } from "aws-amplify";
// @ts-expect-error type exists
import { createActivityLog } from "../../../../graphql/mutations";

const InternalNote = ({
  order,
  onUpdateInternalNote = () => {},
}: {
  order: UserOrder;
  onUpdateInternalNote?: (value: UserOrder) => void;
}) => {
  const { handleOrderUpdate } = useOrder();
  const [{ user }] = useUser();
  const handleCreateActivityLog = async (
    oldNote: string,
    newNote: string,
    orderId?: string,
    lastUpdatedBy?: string
  ) => {
    const logDetails = {
      operation: "CHANGE",
      field: "note",
      value: JSON.stringify([
        `old: ${oldNote}`,
        `new: ${newNote}`,
        `logtype: internal`,
      ]),
      orderItemActivityLogsId: orderId,
      typename: "activityLog",
      updatedBy: lastUpdatedBy, // Setzen Sie hier den aktuellen Benutzernamen
      // ... Fügen Sie andere benötigte Felder hinzu
    };

    try {
      await API.graphql(
        graphqlOperation(createActivityLog, { input: logDetails })
      );
    } catch (error) {
      console.error("Fehler beim Erstellen des Activity Logs:", error);
    }
  };

  const handleUpdateInternalNote = async (internalNote: string) => {
    try {
      if (!order) return;
      const responseOrder = await handleOrderUpdate({
        id: order.id,
        internalNote,
      });
      if (!responseOrder) return;
      onUpdateInternalNote(responseOrder);
      toast.success("Internal Note Updated.");
      if (user?.isAdmin || user?.isManufacturer) {
        await handleCreateActivityLog(
          order.internalNote ?? "",
          internalNote,
          order.id,
          order.lastUpdatedBy
        );
      } else {
        await handleCreateActivityLog(
          order.internalNote ?? "",
          internalNote,
          order.id,
          user?.email || order.email || ""
        );
      }
      // Erstellen Sie einen ActivityLog-Eintrag, wenn die interne Notiz aktualisiert wird
    } catch (error) {
      if (error && (error as Error).message) {
        toast.error((error as Error).message);
      } else {
        toast.error("We are unable to update order please contact admin.");
      }
    }
  };

  return (
    <div className="w-100">
      <div className="m-h-240 box-sizing-bb card-auto p-16 address-details">
        <TextAreaFieldInlineEdit
          label={"internalNote"}
          text={order.internalNote ?? ""}
          isEditable={true}
          onChange={(internalNote) => handleUpdateInternalNote(internalNote)}
        />
      </div>
    </div>
  );
};

export default InternalNote;
